import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {getScoreTheme} from "../../../../../utils/ScoreColorCalculator";

import {greyishBlue700} from "assets/jss/main";

ProductVisualScoring.propTypes = {
    score: PropTypes.number,
    validated: PropTypes.bool
};

function ProductVisualScoring({score = null, validated = true}) {
    if (score === null && validated) {
        return null;
    }

    if (!validated) {
        return (
            <Badge
                rounded={true}
                indicator={'circle'}
                size={'large'}
                labelSize={14}
                color={'draft'}
                labelColor={greyishBlue700}
                isBold={false}
                border={true}
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <span>NA</span>
                    <span style={{display: 'flex', marginLeft: '5px'}}>
                        <InfoTooltipIcon color={greyishBlue700} titleId={'retailer.product.scoring.notValidated.tooltip'}/>
                    </span>
                </div>
            </Badge>
        );
    }

    const scoreTheme = getScoreTheme(score);

    return (
        <Badge
            rounded={true}
            indicator={'circle'}
            size={'large'}
            labelSize={14}
            color={scoreTheme.theme}
            labelColor={scoreTheme.color}
            isBold={false}
            border={true}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <span>
                    <FormattedMessage id={'product.show.resume.image.score'} values={{score}} />
                </span>
                <span style={{display: 'flex', marginLeft: '5px'}}>
                    <InfoTooltipIcon color={scoreTheme.color} titleId="product.show.resume.image.score.tooltip"/>
                </span>
            </div>
        </Badge>
    );
}

export default ProductVisualScoring;
